import { DEFAULT_ICON_PROPS, IIconProps } from './constants';

export const TextfileIcon = ({ ariaLabel = 'File', ...props }: IIconProps) => {
  const { size, width, height, title, ariaHidden, className, strokeWidth } = {
    ...DEFAULT_ICON_PROPS,
    ...props,
  };
  return (
    <svg
      width={size ?? width}
      height={size ?? height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-labelledby={ariaLabel}
      aria-hidden={ariaHidden}
      className={`block ${className}`}
      {...props}
    >
      {title && <title>{title}</title>}
      <path
        d="M14.1857 2.80469H6.18565C5.65522 2.80469 5.14651 3.0154 4.77144 3.39047C4.39637 3.76555 4.18565 4.27425 4.18565 4.80469V20.8047C4.18565 21.3351 4.39637 21.8438 4.77144 22.2189C5.14651 22.594 5.65522 22.8047 6.18565 22.8047H18.1857C18.7161 22.8047 19.2248 22.594 19.5999 22.2189C19.9749 21.8438 20.1857 21.3351 20.1857 20.8047V8.80469L14.1857 2.80469Z"
        className="stroke-current"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.1857 2.80469V8.80469H20.1857"
        className="stroke-current"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.1857 13.8047H8.18565"
        className="stroke-current"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.1857 17.8047H8.18565"
        className="stroke-current"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.1857 9.80469H9.18565H8.18565"
        className="stroke-current"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
